<template>
  <b-modal
    ref="modalEmpresa"
    id="modal-configuracao-empresa"
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="xl"
    @shown="onModalShown"
  >
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #455a64 0%, #263238 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-building text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Configuração de Empresa</h5>
        <small class="text-white opacity-75">Dados cadastrais, NFe, DANFE, séries e e-mail</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar()">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <div class="p-4" style="max-height: 74vh; overflow-y: auto;">
      <div class="modal-section-title mb-3">
        <i class="fa fa-id-card mr-2 text-primary"></i> Dados Cadastrais
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group label="SIGLA" label-for="codempresa">
            <b-form-input id="codempresa" v-model="registro.CODEMPRESA" maxlength="1" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="APELIDO" label-for="apelido">
            <b-form-input id="apelido" v-model="registro.APELIDO" maxlength="50" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Razão Social" label-for="razao">
            <b-form-input id="razao" v-model="registro.RAZAO" maxlength="60" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Fantasia" label-for="fantasia">
            <b-form-input id="fantasia" v-model="registro.FANTASIA" maxlength="60" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="CNPJ" label-for="cnpj">
            <b-form-input id="cnpj" v-model="registro.CNPJ" maxlength="16" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="I.E." label-for="ie">
            <b-form-input id="ie" v-model="registro.IE" maxlength="14" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="I.M." label-for="im">
            <b-form-input id="im" v-model="registro.IM" maxlength="15" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Responsável" label-for="contato">
            <b-form-input id="contato" v-model="registro.CONTATO" maxlength="40" />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-map-marker mr-2 text-success"></i> Endereços
      </div>

      <b-row>
        <b-col md="8">
          <b-form-group label="Endereço" label-for="endereco">
            <b-form-input id="endereco" v-model="registro.ENDERECO" maxlength="80" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Complemento" label-for="complemento">
            <b-form-input id="complemento" v-model="registro.COMPLEMENTO" maxlength="60" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <b-form-group label="Bairro" label-for="bairro">
            <b-form-input id="bairro" v-model="registro.BAIRRO" maxlength="60" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Número" label-for="numero">
            <b-form-input id="numero" v-model="registro.NUMERO" maxlength="60" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="CEP" label-for="cep">
            <b-form-input id="cep" v-model="registro.CEP" maxlength="10" />
          </b-form-group>
        </b-col>
        <b-col md="1">
          <b-form-group label="UF" label-for="id-uf">
            <b-form-select
              id="id-uf"
              v-model="registro.ID_UF"
              :options="estados"
              value-field="ID"
              text-field="ID"
              @change="onChangeUf"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Município" label-for="id-municipio">
            <div class="d-flex align-items-center">
              <b-form-select
                id="id-municipio"
                class="flex-grow-1"
                v-model="registro.ID_MUNICIPIO"
                :options="municipios"
                value-field="ID"
                text-field="NOME"
                :disabled="municipiosBusy || !registro.ID_UF"
              />
              <b-spinner v-if="municipiosBusy" small class="ml-2 text-primary"></b-spinner>
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Telefone" label-for="telefone">
            <b-form-input id="telefone" v-model="registro.TELEFONE" maxlength="13" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Email" label-for="email">
            <b-form-input id="email" v-model="registro.EMAIL" maxlength="100" />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-file-text mr-2 text-warning"></i> Parâmetros para Nota Fiscal
      </div>

      <b-row>
        <b-col md="6">
          <b-form-group label="Linha de Observação 01" label-for="linha1nf">
            <b-form-input id="linha1nf" v-model="registro.LINHA1NF" maxlength="60" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Linha de Observação 02" label-for="linha2nf">
            <b-form-input id="linha2nf" v-model="registro.LINHA2NF" maxlength="60" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="9">
          <b-form-group label="Certificado Digital" label-for="certificado">
            <b-form-input id="certificado" v-model="registro.TX_CERTIFICADO_DIGIAL_NFE" maxlength="500" />
          </b-form-group>
        </b-col>
        <b-col md="3" class="d-flex align-items-end">
          <b-button variant="outline-primary" class="w-100" @click="buscarHashCertificado">Buscar</b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Regime Tributário" label-for="op-regime-tributario">
            <b-form-select id="op-regime-tributario" v-model="registro.OP_REGIME_TRIBUTARIO">
              <option value="1">1 - Simples Nacional</option>
              <option value="2">2 - Simples Nacional - excesso de sublimite da receita bruta</option>
              <option value="3">3 - Regime Normal</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="CFOP Preferencial" label-for="cfop-preferencial">
            <b-form-input id="cfop-preferencial" v-model="registro.CFOP_PREFERENCIAL_ID" maxlength="10" />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-print mr-2 text-info"></i> DANFE
      </div>

      <b-row>
        <b-col md="12">
          <b-form-group label="Tipo de Danfe" label-for="op-tipo-danfe">
            <b-form-select id="op-tipo-danfe" v-model="registro.OP_TIPO_DANFE">
              <option value="0">0 - DANFE Padrão 01</option>
              <option value="1">1 - DANFE Padrão 02 (não permite paisagem)</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-cube mr-2 text-danger"></i> Estoque
      </div>

      <b-row>
        <b-col md="12">
          <b-form-group label="Estoque da NFe" label-for="id-centro-estoque">
            <centro-estoque-drop-down id="id-centro-estoque" v-model="registro.ID_CENTRO_ESTOQUE" />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-image mr-2 text-secondary"></i> Dados da Empresa - DANFE
      </div>

      <b-row>
        <b-col md="4">
          <b-form-group label="Endereços Empresa (máx: 3 linhas)">
            <b-form-textarea v-model="registro.TX_ENDERECO" rows="3" maxlength="100" />
          </b-form-group>
          <b-form-group label="Telefones / Cidade / UF / Email (máx: 3 linhas)">
            <b-form-textarea v-model="registro.TX_TELEFONE" rows="3" maxlength="100" />
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group label="LOGO do Banco de Dados">
            <b-form-file
              accept=".bmp,image/bmp"
              placeholder="Inserir logo .bmp"
              browse-text="Inserir Logo"
              @change="onInserirLogoBmp"
            />
          </b-form-group>

          <b-button variant="outline-danger" class="w-100 mb-2" @click="excluirLogoBanco">Excluir Logo</b-button>
          <b-button variant="outline-secondary" class="w-100 mb-2" @click="salvarLogoLocalmente">Salvar logo localmente</b-button>

          <b-form-checkbox v-model="registro.OP_EXPANDIR_LOGO" value="1" unchecked-value="0" class="mt-2">
            Expandir Logomarca
          </b-form-checkbox>
          <b-form-checkbox v-model="registro.OP_IMPRIME_FANTASIA" value="1" unchecked-value="0">
            Imprimir Nome Fantasia
          </b-form-checkbox>
        </b-col>

        <b-col md="4">
          <div class="logo-preview border rounded d-flex align-items-center justify-content-center">
            <img v-if="logoPreview" :src="logoPreview" alt="Logo" class="logo-preview-img" />
            <span v-else class="text-muted small">Sem logo carregado</span>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <b-form-group label="Percentual do Lucro Presumido">
            <b-form-input v-model.number="registro.CREDITO_PRESUMIDO_PERC" type="number" step="0.01" />
          </b-form-group>
        </b-col>
        <b-col md="5">
          <b-form-group label="PATH do Logo no Arquivo">
            <b-form-input v-model="registro.TX_PATH_LOGO" maxlength="200" />
          </b-form-group>
        </b-col>
        <b-col md="3" class="d-flex align-items-end">
          <b-form-file
            accept=".jpg,.jpeg,image/jpeg"
            placeholder="Selecionar JPG"
            browse-text="..."
            @change="onSelecionarPathLogoArquivo"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Tamanho do Arquivo do LOGO no Arquivo (bytes)">
            <b-form-input v-model="registro.TX_TAMANHO_LOGO" readonly />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-list-ol mr-2 text-dark"></i> Série
      </div>

      <b-row>
        <b-col md="6">
          <b-form-group label="Informe a Série Preferencial">
            <b-form-select v-model="registro.SERIENF" :options="seriesOptions" value-field="value" text-field="text" />
          </b-form-group>
        </b-col>
        <b-col md="2" class="d-flex align-items-end">
          <b-button variant="outline-primary" class="w-100" @click="confirmarNovaSerie">Nova Série</b-button>
        </b-col>
        <b-col md="4" class="d-flex align-items-center">
          <b-form-checkbox v-model="registro.OP_USAR_SERIE_MATRIZ" value="1" unchecked-value="0">
            Usar a mesma série da matriz
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Informe a Série Preferencial (Matriz)">
            <b-form-select
              v-model="registro.EMPRESA_MATRIZ_ID"
              :options="empresasMatrizOptions"
              value-field="value"
              text-field="text"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-envelope mr-2 text-primary"></i> Email
      </div>

      <b-row>
        <b-col md="5">
          <b-form-group label="Email">
            <b-form-input v-model="registro.TX_EMAIL" maxlength="40" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Host">
            <b-form-input v-model="registro.TX_HOST_EMAIL" maxlength="100" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Porta">
            <b-form-input v-model.number="registro.NR_PORTA_EMAIL" type="number" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-form-group label="Usuário">
            <b-form-input v-model="registro.TX_USUARIO_EMAIL" maxlength="200" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Senha">
            <b-form-input type="password" v-model="registro.TX_SENHA_EMAIL" maxlength="100" />
          </b-form-group>
        </b-col>
        <b-col md="3" class="d-flex align-items-center pt-4">
          <b-form-checkbox v-model="registro.OP_AUTENTICA_SMTP" value="1" unchecked-value="0">
            Autentica SMTP SSL
          </b-form-checkbox>
        </b-col>
        <b-col md="3" class="d-flex align-items-end">
          <b-button variant="outline-secondary" class="w-100" disabled @click="testarEmail">Testar</b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Destinatário Teste">
            <b-form-input v-model="emailTeste.destinatario" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="CC Teste (separe com ;)">
            <b-form-input v-model="emailTeste.cc" disabled />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Email (Assunto)">
            <b-form-input v-model="registro.TX_ASSUNTO_EMAIL_NFE" maxlength="200" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Corpo do Email">
            <b-form-textarea v-model="registro.TX_CORPO_EMAIL_NFE" rows="5" maxlength="2000" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Pasta onde ficam os anexos">
            <b-form-input v-model="registro.TX_PATH_ANEXO_NFE" maxlength="200" />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
      <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar()">
        CANCELAR
      </b-button>
      <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="salvar()">
        <i class="fa fa-check-circle mr-1"></i> SALVAR
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import CentroEstoqueDropDown from '../views/componentes/dropdown/CentroEstoqueDropDown.vue'

export default {
  name: 'ModalConfiguracaoEmpresa',
  components: {
    CentroEstoqueDropDown
  },
  data() {
    return {
      estados: [],
      municipios: [],
      municipiosBusy: false,
      seriesOptions: [],
      empresasMatrizOptions: [],
      emailTeste: {
        destinatario: '',
        cc: ''
      },
      registro: this.getRegistroVazio()
    }
  },
  computed: {
    logoPreview() {
      if (!this.registro.LOGO) return ''
      return `data:image/bmp;base64,${this.registro.LOGO}`
    }
  },
  methods: {
    getRegistroVazio() {
      return {
        CONTADOR: null,
        CODIGO: null,
        CODEMPRESA: '',
        APELIDO: '',
        RAZAO: '',
        FANTASIA: '',
        CNPJ: '',
        IE: '',
        IM: '',
        CONTATO: '',
        ENDERECO: '',
        COMPLEMENTO: '',
        BAIRRO: '',
        NUMERO: '',
        CEP: '',
        ID_UF: null,
        ID_MUNICIPIO: null,
        TELEFONE: '',
        EMAIL: '',
        LINHA1NF: '',
        LINHA2NF: '',
        TX_CERTIFICADO_DIGIAL_NFE: '',
        OP_REGIME_TRIBUTARIO: '1',
        CFOP_PREFERENCIAL_ID: '',
        OP_TIPO_DANFE: '0',
        ID_CENTRO_ESTOQUE: null,
        TX_ENDERECO: '',
        TX_TELEFONE: '',
        LOGO: '',
        OP_EXPANDIR_LOGO: '0',
        OP_IMPRIME_FANTASIA: '0',
        CREDITO_PRESUMIDO_PERC: 0,
        TX_PATH_LOGO: '',
        TX_TAMANHO_LOGO: 0,
        SERIENF: null,
        OP_USAR_SERIE_MATRIZ: '0',
        EMPRESA_MATRIZ_ID: null,
        TX_EMAIL: '',
        TX_HOST_EMAIL: '',
        NR_PORTA_EMAIL: null,
        TX_USUARIO_EMAIL: '',
        TX_SENHA_EMAIL: '',
        OP_AUTENTICA_SMTP: '0',
        TX_ASSUNTO_EMAIL_NFE: '',
        TX_CORPO_EMAIL_NFE: '',
        TX_PATH_ANEXO_NFE: ''
      }
    },
    abrir() {
      this.$refs.modalEmpresa.show()
    },
    fechar() {
      this.$refs.modalEmpresa.hide()
    },
    async onModalShown() {
      await this.carregarEstados()
      await this.carregarDadosEmpresa()
      await this.carregarEmpresasMatriz()
      await this.carregarSeries()
    },
    async carregarDadosEmpresa() {
      try {
        const { data } = await this.$http.get('/api/protected/empresa/getPreferencial')
        if (data && data.length) {
          const empresa = data[0]
          const trimChar = value => (value === null || value === undefined) ? '' : String(value).trim()

          this.registro = {
            ...this.getRegistroVazio(),
            ...empresa,
            ID_UF: trimChar(empresa.ID_UF),
            ID_MUNICIPIO: trimChar(empresa.ID_MUNICIPIO),
            OP_REGIME_TRIBUTARIO: trimChar(empresa.OP_REGIME_TRIBUTARIO) || '1',
            OP_TIPO_DANFE: trimChar(empresa.OP_TIPO_DANFE) || '0',
            OP_USAR_SERIE_MATRIZ: trimChar(empresa.OP_USAR_SERIE_MATRIZ) || '0',
            OP_EXPANDIR_LOGO: trimChar(empresa.OP_EXPANDIR_LOGO) || '0',
            OP_IMPRIME_FANTASIA: trimChar(empresa.OP_IMPRIME_FANTASIA) || '0',
            OP_AUTENTICA_SMTP: trimChar(empresa.OP_AUTENTICA_SMTP) || '0',
            SERIENF: trimChar(empresa.SERIENF)
          }

          if (this.registro.ID_UF) {
            await this.carregarMunicipios()
          }
        }
      } catch (err) {
        this.$root.$bvToast.toast('Erro ao carregar dados da empresa', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    async carregarEstados() {
      try {
        const result = await this.$http.get('/api/protected/estados')
        this.estados = result.data || []
      } catch (err) {
        this.estados = []
      }
    },
    async carregarMunicipios() {
      this.municipiosBusy = true
      this.municipios = []

      if (this.registro.ID_UF) {
        try {
          const result = await this.$http.get(`/api/protected/municipios/${this.registro.ID_UF}`)
          this.municipios = result.data || []
        } catch (err) {
          this.municipios = []
        }
      }
      this.municipiosBusy = false
    },
    async onChangeUf() {
      this.registro.ID_MUNICIPIO = null
      await this.carregarMunicipios()
    },
    async carregarEmpresasMatriz() {
      try {
        const { data } = await this.$http.get('/api/protected/empresa/getTodas')
        this.empresasMatrizOptions = (data || []).map(item => ({
          value: item.CONTADOR,
          text: `${item.CNPJ || ''}`.trim() ? `${item.CNPJ} - ${item.APELIDO || ''}` : `${item.CONTADOR}`
        }))
      } catch (err) {
        this.empresasMatrizOptions = []
      }
    },
    async carregarSeries() {
      if (!this.registro.CONTADOR) {
        this.seriesOptions = []
        return
      }

      try {
        const { data } = await this.$http.get(`/api/protected/empresa/getSeries/${this.registro.CONTADOR}`)
        this.seriesOptions = (data || []).map(item => ({
          value: item.SERIE,
          text: `${item.SERIE} - Último: ${item.NR_SERIE || 0}`
        }))
      } catch (err) {
        this.seriesOptions = []
      }
    },
    async confirmarNovaSerie() {
      if (!this.registro.CODIGO) {
        this.$root.$bvToast.toast('Empresa não carregada para criar série', {
          title: 'Atenção',
          variant: 'warning',
          autoHideDelay: 3500
        })
        return
      }

      const confirmar = await this.$bvModal.msgBoxConfirm(
        'Confirma criar uma nova série para esta empresa?',
        {
          title: 'Confirmação',
          okVariant: 'primary',
          okTitle: 'Sim, criar',
          cancelTitle: 'Cancelar'
        }
      )

      if (!confirmar) return

      try {
        const { data } = await this.$http.post('/api/protected/empresa/criarNovaSerie', {
          codigoEmpresa: this.registro.CODIGO
        })

        await this.carregarSeries()
        this.registro.SERIENF = data.serie

        this.$root.$bvToast.toast(data.mensagem || 'Nova série criada com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          autoHideDelay: 3500
        })
      } catch (err) {
        this.$root.$bvToast.toast(err.response?.data || 'Erro ao criar série', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    buscarHashCertificado() {
      this.$root.$bvToast.toast('Leitura automática de hash do certificado no browser não está disponível neste ambiente. Informe o hash manualmente.', {
        title: 'Informação',
        variant: 'info',
        autoHideDelay: 5000
      })
    },
    onInserirLogoBmp(event) {
      const file = event && event.target && event.target.files ? event.target.files[0] : null
      if (!file) return

      const ext = (file.name || '').split('.').pop().toLowerCase()
      if (ext !== 'bmp') {
        this.$root.$bvToast.toast('Selecione um arquivo .bmp para o logo do banco', {
          title: 'Atenção',
          variant: 'warning',
          autoHideDelay: 3500
        })
        return
      }

      const reader = new FileReader()
      reader.onload = () => {
        const partes = String(reader.result || '').split(',')
        this.registro.LOGO = partes.length > 1 ? partes[1] : ''
      }
      reader.readAsDataURL(file)
    },
    excluirLogoBanco() {
      this.registro.LOGO = ''
    },
    salvarLogoLocalmente() {
      if (!this.registro.LOGO) {
        this.$root.$bvToast.toast('Não há logo carregado para salvar', {
          title: 'Aviso',
          variant: 'warning',
          autoHideDelay: 3000
        })
        return
      }

      const a = document.createElement('a')
      a.href = `data:image/bmp;base64,${this.registro.LOGO}`
      a.download = 'logo_empresa.bmp'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    onSelecionarPathLogoArquivo(event) {
      const file = event && event.target && event.target.files ? event.target.files[0] : null
      if (!file) return

      const ext = (file.name || '').split('.').pop().toLowerCase()
      if (ext !== 'jpg' && ext !== 'jpeg') {
        this.$root.$bvToast.toast('Selecione arquivo .jpg para o path do logo em arquivo', {
          title: 'Atenção',
          variant: 'warning',
          autoHideDelay: 3500
        })
        return
      }

      this.registro.TX_PATH_LOGO = file.name
      this.registro.TX_TAMANHO_LOGO = file.size
    },
    testarEmail() {
      this.$root.$bvToast.toast('Funcionalidade de teste de e-mail ainda não implementada.', {
        title: 'Informação',
        variant: 'info',
        autoHideDelay: 3000
      })
    },
    async salvar() {
      try {
        const payload = { registro: this.registro }
        const { data } = await this.$http.post('/api/protected/empresa/update', payload)

        this.$root.$bvToast.toast(data.mensagem || 'Empresa atualizada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          autoHideDelay: 3500
        })

        this.fechar()
      } catch (err) {
        this.$root.$bvToast.toast(err.response?.data || 'Erro ao salvar empresa', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.logo-preview {
  min-height: 170px;
  background: #f8fafc;
}

.logo-preview-img {
  max-width: 100%;
  max-height: 160px;
  object-fit: contain;
}

.opacity-75 {
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/modals/ModalConfiguracaoEmpresa.vue